import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import type { CollectionUUID } from '@library/menu-service'

import type { SelectCollectionCallback } from 'actions/menu-collections/selectCollection'
import { selectCollection } from 'actions/menu-collections/selectCollection'

export const useSelectCollection = () => {
  const dispatch = useDispatch()

  return useCallback(
    (id: CollectionUUID, callback: SelectCollectionCallback = () => {}) => {
      dispatch(selectCollection(id, callback))
    },
    [dispatch],
  )
}
